import React, { useEffect } from "react";

import logo_footer from "../static/images/logo-footer.svg";
import blog1 from "../static/images/Blog-1.png";
import blog2 from "../static/images/Blog-2.png";
import childre from "../static/images/Nuevo-Logo-ChildrenBelieve-blanco.webp";

import { Link, useLocation } from "react-router-dom";
import { ScrollTo } from "../utils/ScrollTo";
import { Url } from "../utils/Url/Url";

function FooterHome() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const location = useLocation();

  function Inicio() {
    return location.pathname === "/";
  }
  function Sobrenosotros() {
    return location.pathname === "/Sobrenosotros";
  }

  return (
    <section className="footer">
      <div className="footer-bottom">
        <div className="container">
          <div className="row" id="rowsocialmedia">
            <div className="col social-media">
              <img
                src={logo_footer}
                alt="Logo Krezco"
                className="logo-footer"
              ></img>
              <div className="title"></div>
              <ul>
                <li className="facebook">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/childrenbelieveni"
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
                <li className="twitter">
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/children-believe/posts/?feedView=all"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
                <li className="youtube">
                  <a
                    target="_blank"
                    href="https://www.youtube.com/channel/UCSYikpDt6v7Ki2g2ZfBERVQ"
                  >
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
                <li className="instagram">
                  <a
                    target="_blank"
                    href="https://www.instagram.com/childrenbelieveni/?hl=en"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div className="col col-2 ">
              <div className="title">Conoce más</div>
              <ul>
                <li>
                  <a
                    href="/#sectionmision"
                    onClick={() => {
                      if (Inicio()) {
                        ScrollTo("sectionmision");
                      }
                    }}
                  >
                    Misión
                  </a>
                </li>
                <li>
                  <Link to="/Sobrenosotros">Sobre Nosotros</Link>
                </li>
                <li>
                  <Link to="/Teayudamos">¡Te Ayudamos!</Link>
                </li>
                <li>
                  <Link to="/Registrate">Registrate</Link>
                </li>
              </ul>
            </div>

            <div className="col">
              <div className="title">Un sitio de:</div>
              <div className="col-10 d-flex">
                <a
                  target="_blank"
                  href="https://countries.childrenbelieve.ca/nicaragua/"
                >
                  <img
                    src={childre}
                    style={{ height: "100%", width: "60%", margin: "0px" }}
                    alt="Download Our Insurance Secrets FREE eBook"
                  ></img>
                </a>
              </div>

              {/** 
              <div className="row">
                <div className="col-4 left-side">
                  <img
                    src={blog2}
                    alt="Download Our Insurance Secrets FREE eBook"
                  ></img>
                </div>
                <div className="col-8 right-side">
                  <div className="sub-title">
                    <span>9 Octubre 2020</span>
                    Lista de control de <br />
                    diversidad e inclusión
                  </div>
                </div>
              </div>*/}
            </div>

            <div className="col cuidades">
              <div className="title">Contacto</div>
              <div className="direccion">
                <div className="title">Dirección:</div>
                <p>
                  Pista Suburbana, Costado Oeste del Colegio Americano
                  Nicaragüense
                </p>
                <p> Edificio San Dionisio C2, 3er piso.</p>
              </div>

              <div className="telefono">
                <div className="title">Teléfonos:</div>
                <p>
                  <a href="tel:50522232250">2223 2250</a>
                </p>
                <p>
                  <a href="tel:50522232211">2223 2211</a>
                </p>
              </div>

              <div className="email">
                <div className="title">Correo Electrónico: </div>
                <p>
                  <a href="mailto:nicaraguainfo@childrenbelieve.ca">
                    nicaraguainfo@childrenbelieve.ca
                  </a>
                </p>
              </div>
              {/* <ul>
                    <li><a href="#">Managua</a></li>
                    <li><a href="#">Masaya</a></li>
                    <li><a href="#">Granada</a></li>
                    <li><a href="#">Isla de Ometepe</a></li> 
    
                    <li><a href="#">Matagalpa</a></li>
                    <li><a href="#">Boaco</a></li>
                    <li><a href="#">Chinandega</a></li>
                    <li><a href="#">Estelí</a></li>
                    <li><a href="#">Rivas</a></li>
                </ul> */}
            </div>
          </div>
        </div>
      </div>
      <div className="disclaimer-footer">
        <p>
          Esta es una plataforma de Children Believe, desarrollada en el Marco
          del Proyecto Empuje (Cerrando la Brecha de Género en la Empleabilidad
          Juvenil)
        </p>
      </div>
      <div className="copyright-footer">
        <p>© 2022 Children Believe. Todos los derechos reservados</p>
      </div>
    </section>
  );
}

export default FooterHome;
